import type { BlockInstance, TemplateModel, WebsitePage } from '@troia-v3/types';

/** Nível atual da navegação drill-down do painel. */
export type PanelLevel =
  | { kind: 'root' }
  | { kind: 'global-group'; group: string }
  | { kind: 'pages' }
  | { kind: 'page'; pageId: string }
  | { kind: 'page-seo'; pageId: string }
  | { kind: 'block'; pageId: string; instanceId: string }
  | { kind: 'add-block'; pageId: string }
  | { kind: 'choose-layout'; pageId: string }
  | { kind: 'databases' }
  | { kind: 'domains' };

/** Bloco alterado na sessão que também existe em outras páginas (modal do Salvar). */
export interface ApplyCandidate {
  key: string; // `${sourcePageId}|${instanceId}`
  blockId: string;
  sourceInstanceId: string;
  blockName: string;
  sourcePageId: string;
  sourcePageName: string;
  fields: string[];
  fieldLabels: string[];
  targets: Array<{ pageId: string; pageName: string }>;
}

export function getPageName(model: TemplateModel | undefined, pageId: string): string {
  return model?.pages.find((p) => p.id === pageId)?.name || pageId;
}

export function getBlockName(model: TemplateModel | undefined, blockId: string): string {
  return model?.blocks.find((b) => b.id === blockId)?.name || blockId;
}

/**
 * Ordenação canônica dos blocos de uma página (order asc). PanelPage exibe e o
 * handler de mover bloco DEVE derivar vizinhos por esta mesma ordenação.
 */
export function sortBlocksByOrder(blocks: BlockInstance[]): BlockInstance[] {
  return [...blocks].sort((a, b) => a.order - b.order);
}

/** Quantas instâncias de um blockId existem na página (inclui ocultas). */
export function countBlockInstances(page: WebsitePage, blockId: string): number {
  return page.blocks.filter((b) => b.blockId === blockId).length;
}

/**
 * Pode adicionar/duplicar mais uma instância de blockId nesta página?
 * Respeita maxInstances do template (ausente = ilimitado).
 */
export function canAddBlock(model: TemplateModel | undefined, page: WebsitePage, blockId: string): boolean {
  const max = model?.blocks.find((b) => b.id === blockId)?.maxInstances;
  if (max === undefined) return true;
  return countBlockInstances(page, blockId) < max;
}
